import { useQ } from '@olagg/api-hooks';
import { AdminPushNotificationEndpoints } from '@olagg/api-hooks/endpoints/adminEndpoints';
import { PushNotificationResponse } from './types';

export const usePushNotification = (uid: string) => {
  const response = useQ<PushNotificationResponse>(
    AdminPushNotificationEndpoints.find(uid),
    {
      revalidateOnFocus: false,
    }
  );

  return {
    ...response,
    pushNotification: response.data?.pushNotification,
  };
};
